import { Component } from '@angular/core';
import { FormGroupDirective, ControlContainer } from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { AppState } from '@store/state/app.state';
import { getVariation } from '@store/selectors/config.selector';

@Component({
    selector: 'app-variation-select',
    templateUrl: './variation-select.component.html',
    styleUrls: ['./variation-select.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useExisting: FormGroupDirective
        }
    ],
    standalone: false
})
export class VariationSelectComponent {

  public variations$ = this.store.pipe(select(getVariation));

  constructor(public store: Store<AppState>) {
  }

}
